import { Text } from '@react-pdf/renderer';
// eslint-disable-next-line no-restricted-imports
import { tv } from 'tailwind-variants';

import { tw } from '../pdf-tw';

const styles = tv({
  slots: {
    footer: 'text-textSecondary absolute right-8 bottom-8 left-8 text-right',
  },
})();

// fontSize is applied inline (not via the `text-body-sm` tailwind class) because
// `text-body-sm` also emits `lineHeight: 1.5` (multiplier form), and under
// @react-pdf/renderer v4 a multiplier `lineHeight` on a <Text render={...}>
// element collapses the text to zero height during dynamic-node relayout, so
// the page-count footer disappears entirely. See ENG-3423 / ENG-3586.
const FOOTER_FONT_SIZE = 9;

export const PageFooter = () => {
  return (
    <Text
      fixed
      style={[tw(styles.footer()), { fontSize: FOOTER_FONT_SIZE }]}
      render={({ pageNumber, totalPages }) =>
        totalPages === 1 ? '' : `Page ${pageNumber} of ${totalPages}`
      }
    />
  );
};
